/**
 * @file: useViewQuotation.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { useTaskNavigation } from '@euler/app/flows/task/functions/useTaskNavigation';
import { useAppLoading } from '@euler/components/loading/Provider';
import { CommonTaskStatus } from '@euler/model/enum';
import { safeMarkDevFlag } from '@euler/utils';
import { usePersistFn } from '@euler/utils/hooks';

const kAlwaysShowQuotationForm = safeMarkDevFlag(false);

export const useViewQuotation = () => {
  const loading = useAppLoading();
  const navigation = useTaskNavigation();
  const { taskManager, detail } = useTaskContext();

  return usePersistFn(() => {
    // try load the task detail to verify the settlement status
    let settlementStatus = detail.basicInfo.settlementStatus;
    loading.show();
    void taskManager.sync({
      callback: (_err, resp) => {
        loading.hide();
        if (resp == null) {
          return;
        }
        if ('basicInfo' in resp.response) {
          settlementStatus = resp.response.basicInfo.settlementStatus;
        }
        navigation.navigate('_quotation', {
          screen:
            settlementStatus !== CommonTaskStatus.Finished ||
            kAlwaysShowQuotationForm
              ? '_main'
              : '_settlementForm',
          params: {},
        });
      },
    });
  });
};
